export { default } from './WordLexiconDetails';
